import { useFormContext, useWatch } from "react-hook-form";

import { Editor } from "@/react/components/CommentsCompass/Editor";
import { isTiptapDocumentBlank } from "@/react/components/CommentsCompass/helpers";
import type { TiptapFormValues } from "@/react/components/CommentsCompass/types";

import { EditModalShell } from "./EditModalShell";

export const FORM_ID = "comment-edit-tiptap-form";

interface TiptapEditBodyProps {
  shouldSupportTables: boolean;
  spaceId: number;
}

export const TiptapEditBody = ({
  shouldSupportTables,
  spaceId,
}: TiptapEditBodyProps) => {
  const { control } = useFormContext<TiptapFormValues>();
  const body = useWatch({ control, name: "tiptap_body.body" });

  return (
    <EditModalShell formId={FORM_ID} disabled={isTiptapDocumentBlank(body)}>
      <Editor
        formId={FORM_ID}
        spaceId={spaceId}
        shouldSupportTables={shouldSupportTables}
        hideSubmitButton
        autoFocus
      />
    </EditModalShell>
  );
};
